import React, { useEffect, useContext, useState } from 'react'
import {
  Container
} from 'reactstrap'
import { get, isEmpty } from 'lodash'
import { withNamespaces } from 'react-i18next'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ApiService from '../../data/services/ApiService'
import Share from './components/Share'
import { GeneralContext } from '../../context/'

const StoreCreate = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading } = generalContext

  const [store, setStore] = useState({})

  const storeId = get(props, 'match.params.storeId', false)

  useEffect(() => {
    (async () => {
      if (storeId) {
        await fetchStoreById(storeId)
      }
    })()

    async function fetchStoreById(id) {
      setLoading(true)
      const response = await ApiService.getStoreById(id)
      setStore(response.data.data)
      setLoading(false)
    }
  }, [storeId]) // eslint-disable-line

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Mi tienda"
            breadcrumbItem={!isEmpty(store) ? store.name : 'Mi tienda'}
            parentLink={`/mi-tienda`}
          />
          <Share />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withNamespaces()(StoreCreate)
